import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_ODOMETER_LOGS } from './vehicleEntityConfigs';

const VehicleOdometerLogs = () => <VehicleEntityGridPage config={VEHICLE_ODOMETER_LOGS} />;

export default VehicleOdometerLogs;
